/**
 * @generated SignedSource<<ad25385d8a40a53defb66879c8dcd155>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type queriesGetSubmissionsSimilarNamesQuery$variables = {
  name: string;
};
export type queriesGetSubmissionsSimilarNamesQuery$data = {
  readonly sys_submissions: ReadonlyArray<{
    readonly submission_name: string;
  }>;
};
export type queriesGetSubmissionsSimilarNamesQuery = {
  response: queriesGetSubmissionsSimilarNamesQuery$data;
  variables: queriesGetSubmissionsSimilarNamesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_ilike",
                "variableName": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "submission_name"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_submissions",
    "kind": "LinkedField",
    "name": "sys_submissions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "submission_name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queriesGetSubmissionsSimilarNamesQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queriesGetSubmissionsSimilarNamesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "36896f3ec178e301f874d4c169eadf0f",
    "id": null,
    "metadata": {},
    "name": "queriesGetSubmissionsSimilarNamesQuery",
    "operationKind": "query",
    "text": "query queriesGetSubmissionsSimilarNamesQuery(\n  $name: String!\n) {\n  sys_submissions(where: {submission_name: {_ilike: $name}}) {\n    submission_name\n  }\n}\n"
  }
};
})();

(node as any).hash = "9aa6db85b55f1da43acb406bc7b43dc6";

export default node;
